import { Box, Button, Dialog, DialogActions, DialogTitle, Divider, Paper, TextField } from '@material-ui/core';
import { DeleteForever, Person } from '@material-ui/icons';
import React, { useCallback, useState } from 'react';

const AdminMenu: React.FC<{
  onAddUser: () => void;
  onDeleteUsers?: () => void;
  onSearch?: (searchText: string) => void;
}> = ({ onAddUser, onDeleteUsers, onSearch }) => {
  const [open, toggleOpen] = useState(false);

  const handleDeleteUsers = useCallback(() => {
    onDeleteUsers && onDeleteUsers();
    toggleOpen(false);
  }, [onDeleteUsers]);

  return (
    <Paper variant="outlined">
      <Dialog open={open} onClose={() => toggleOpen(false)}>
        <DialogTitle>Attenzione!</DialogTitle>
        <Box padding={3} paddingTop={0}>
          Sei sicuro di voler eliminare le utenze selezionate?
          <br />
          L'azione è irreversibile.
        </Box>
        <DialogActions>
          <Button onClick={() => toggleOpen(false)}>Annulla</Button>
          <Button onClick={handleDeleteUsers} variant="contained" color="primary" disableElevation>
            Conferma
          </Button>
        </DialogActions>
      </Dialog>
      <Box padding={2}>
        <small>Admin menu</small>
        <Divider style={{ margin: 10 }} />
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <TextField
            label="Cerca per email"
            variant="outlined"
            size="small"
            onChange={(e) => onSearch && onSearch(e.target.value)}
          />
          <Box>
            <Button style={{ marginRight: 5 }} variant="contained" color="primary" disableElevation onClick={onAddUser}>
              <Person style={{ marginRight: 5 }} /> Nuovo Cliente
            </Button>
            <Button
              style={{ marginRight: 5 }}
              variant="contained"
              color="primary"
              disableElevation
              disabled={!onDeleteUsers}
              onClick={() => toggleOpen(true)}
            >
              <DeleteForever style={{ marginRight: 5 }} /> Elimina
            </Button>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};
export default AdminMenu;
